require('./profile.module');
require('./controllers/ascent.controller');
require('./controllers/events.controller');
require('./controllers/edit.controller');
require('./controllers/membership.controller');
require('./controllers/notice.controller');
require('./controllers/discharge.controller');
require('./controllers/sidebar.controller');